/**
 *   Generated file. Do not edit
 */

export const ResourceMetaData = {
  '/data-log/options': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/DataLogOption',
      },
    },
  },

  '/data-log/crypto-key': {
    put: {
      minApiVersion: 1.0,
      configModeRequired: true,
      schema: {
        $ref: './definitions.yaml#/Bytes',
      },
    },
  },
};
